import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	stroke: "#000",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M17 1L1 17",
		strokeWidth: 1.6
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1 1L17 17",
		strokeWidth: 1.6
	})]
});
export default SvgClose;
